export default path => () => import(`../../views/front${path}.vue`);



// WEBPACK FOOTER //
// ./src/router/front/view.js